import { Menu } from 'antd';
import { baseFilesURL } from 'App/api/agent/axios/configuration';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import appLogo from '../../assets/thali-wroclaw.png';

const HomeMenuItem = (props) => {
	const { t } = useTranslation('page');
	return (
		<Menu.Item {...props} key='/'>
			<Link to='/'>
				<img width={59} alt={t('Common.NavbarContainer.Home')} src={appLogo} />
			</Link>
		</Menu.Item>
	);
};

export default HomeMenuItem;
